import { clsx } from 'clsx'

import { MediaType, type SpaceHeaderProps } from '../../types.js'
import { getContentSpacingClass } from '../../utils/utils.js'
import { ContentRenderer } from '../ContentRenderer.js'
import { MediaRenderer } from '../MediaRenderer.js'

export const MediaFullPresetRenderer = ({
  contentSpacing,
  textColor,
  contentAlignment,
  mediaType,
  image,
  video,
  mediaTint,
  backgroundColor,
  fields,
  spaceId,
}: SpaceHeaderProps) => {
  const spacingClass = getContentSpacingClass(contentSpacing)
  const renderMedia = mediaType !== MediaType.None

  return (
    <div
      className={clsx(
        'relative overflow-hidden screen-rounded-none screen-border-x-0',
        renderMedia && 'shadow-card border-base border-card rounded-base',
      )}
      style={{ backgroundColor: renderMedia ? backgroundColor : 'transparent' }}
    >
      <ContentRenderer
        textColor={textColor}
        alignment={contentAlignment}
        className={clsx(
          'px-6 @3xl:px-10 @5xl:px-16',
          !renderMedia && 'sm:px-0',
          spacingClass,
        )}
        fields={fields}
        spaceId={spaceId}
        isSimple={!renderMedia}
      />
      {renderMedia && (
        <MediaRenderer
          mediaType={mediaType}
          image={image}
          video={video}
          mediaTint={mediaTint}
          textColor={textColor}
        />
      )}
    </div>
  )
}
